// extracted by mini-css-extract-plugin
export var cardIcon = "_8z-5";
export var cardIconUnframed = "_8z-9";
export var checkboxCard = "_8z-0";
export var checkboxCardSelected = "_8z-4";
export var disabled = "_8z-2";
export var interactive = "_8z-1";
export var outerBorder = "_8z-3";
export var spacerMedium = "_8z-8";
export var spacerSmall = "_8z-7";
export var spacerXsmall = "_8z-6";